import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const e = a((s, c) => /* @__PURE__ */ l.jsx(
  i,
  {
    ref: c,
    ...s,
    image: (o) => /* @__PURE__ */ l.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 90,
        height: 100,
        fill: "none",
        viewBox: "0 0 90 100",
        ...o,
        children: [
          /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "#1D1D44",
              d: "m72.326 75.02-.27.63c-4.93 11.21-13.47 19.56-22.82 22.35-2.33.69-6.26.69-8.58 0-9.36-2.79-17.89-11.14-22.82-22.35l-.27-.63q-.105 1.65-.09 3.39c5.22 10.52 13.6 18.3 22.76 21.02 1.3.39 3.01.58 4.72.58s3.42-.19 4.72-.58c9.18-2.73 17.57-10.54 22.76-21.03q0-1.74-.09-3.39z"
            }
          ),
          /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "#1D1D44",
              d: "M44.946 85.54c1.27 0 2.46-.49 3.36-1.39l2.28-2.28-.99-1-2.28 2.28c-1.26 1.26-3.47 1.26-4.73 0l-2.28-2.28-.99.99 2.28 2.28c.9.9 2.09 1.39 3.36 1.39zM52.236 90.82l-.55-1.29c-6.64 2.85-13.4.03-13.47 0l-.55 1.29c.2.08 3.34 1.4 7.53 1.4 2.16 0 4.6-.35 7.05-1.4zM37.216 60.07l.81-1.26c-2.53-1.64-9.7-3.7-14.83-2.74-.36.59-.71 1.2-1.05 1.82 4.35-1.58 12.16.29 15.07 2.18M37.626 64.7l-.8-1.16c-6.02 4.17-11.97.17-12.23 0l-.8 1.16s3.13 2.11 7.19 2.11c2.05 0 4.35-.53 6.63-2.11zM51.846 58.81l.81 1.26c2.91-1.88 10.72-3.76 15.07-2.18-.34-.62-.69-1.23-1.05-1.82-5.13-.96-12.3 1.1-14.83 2.74M66.086 64.7l-.8-1.16c-.25.17-6.21 4.17-12.22 0l-.8 1.16c2.29 1.58 4.58 2.11 6.63 2.11 4.07 0 7.14-2.08 7.19-2.11"
            }
          ),
          /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "#1D1D44",
              d: "M88.716 43.66C84.796 16.28 67.106 0 44.946 0S5.086 16.28 1.166 43.66c-1.79 12.49-1.23 32.4-.24 40.22 1.1 8.78 19.05 13.49 19.05 13.49-1.75-7.17-2.52-13.44-2.52-18.96 0-1.16.03-2.3.09-3.39.41-6.91 2.11-12.51 4.59-17.12.34-.62.69-1.23 1.05-1.82 5.57-8.98 14.24-13.89 21.74-17.4 7.5 3.52 16.17 8.43 21.74 17.4.37.59.71 1.2 1.05 1.82 2.49 4.61 4.18 10.21 4.59 17.12q.105 1.65.09 3.39c0 5.51-.77 11.79-2.52 18.96 0 0 17.95-4.71 19.05-13.49.99-7.82 1.55-27.73-.24-40.22zM45.006 34c-2.68-9.54-2.66-19.46 0-29 2.66 9.54 2.68 19.46 0 29"
            }
          )
        ]
      }
    )
  }
));
e.displayName = "HairLossFemale1Icon";
export {
  e as HairLossFemale1Icon,
  e as default
};
//# sourceMappingURL=index.js.map
